/* Naoko — wspólny silnik LP z zapisem na listę (docs/lp-bf-vip-swetry-plan.md §4).
   Przeniesiony z naoko-bfv.js (sprawdzony na produkcji) i uogólniony z klas na atrybuty data-vip-*,
   żeby kolejne LP robiły tylko sekcje wyglądu. naoko-bfv-* zostaje na własnym skrypcie.

   Korzeń każdej sekcji: [data-vip]. Elementy:
   - [data-vip-hero] + video[data-vip-video]: plik desktop/mobile (data-src-d/-m, zapas data-fb-d/-m,
     próg w data-desk), plakat do startu (klasa is-playing), pauza poza kadrem; przy błędzie oryginału
     przełączenie na rendition Shopify; prefers-reduced-motion / oszczędzanie danych = sam plakat,
   - [data-vip-zapis] + form[data-vip-form]: walidacja przed NATYWNYM submitem (captcha Shopify
     blokuje AJAX), imię przez sessionStorage (nie URL — PII w GA4/Meta), klucze z data-vip-key;
     ?typ=1 (klasa is-typ z naoko-vip-guard) → przewinięcie do sekcji; potwierdzony zapis = atrybut
     data-bfv-signup (kontrakt z GTM, AIIT-234) + event Meta, raz na wysłanie formularza,
   - [data-vip-copy]: kopiowanie linku do zaproszenia (origin + pathname),
   - [data-vip-pick]: przełącznik (pigułki) — przyciski [data-vip-opt] z aria-pressed, elementy
     [data-vip-item] z klasą is-active, [data-vip-anim] z ponowioną klasą is-anim,
   - [data-vip-rv]: wjazd przy wejściu w kadr (klasa vip-rv-on na korzeniu, is-in na elemencie);
     nie w edytorze motywu (IntersectionObserver nie odpala w panelu podglądu),
   - kotwice a[href^="#"] przewijane z odjęciem sticky nagłówka i banerów; z data-vip-scroll-ms="N"
     na linku — własna animacja trwająca N ms (natywne smooth ~0,6–0,7 s, nie da się go spowolnić),
     przerywana kółkiem, dotykiem lub klawiszem.
   Inicjalizacja idempotentna (data-vip-*) — edytor motywu re-renderuje sekcje. Każda sekcja dołącza
   ten skrypt, a przeglądarka wykonuje każdy <script> osobno — stąd blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoVip) return;
  window.NaokoVip = true;

  var ORDER = ['fname', 'email', 'consent'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function headerOffset() {
    var cs = getComputedStyle(document.body);
    return (parseFloat(cs.getPropertyValue('--header-height')) || 0) +
      (parseFloat(cs.getPropertyValue('--naoko-sticky-banners-height')) || 0);
  }

  /* Cel przewijania: góra sekcji pod nagłówkiem. Gdy sekcja ma [data-vip-focus] (np. arkusz
     formularza), środkujemy ich wspólny obrys w widocznej części okna — na niskim ekranie
     formularz nie ucieka pod dolną krawędź; za wysoki = jego góra 16 px pod nagłówkiem.
     Nigdy wyżej niż góra sekcji. */
  function targetY(el) {
    var sy = window.scrollY || window.pageYOffset || 0;
    var off = headerOffset();
    var y = el.getBoundingClientRect().top + sy - off;
    var top = Infinity, bottom = -Infinity;
    el.querySelectorAll('[data-vip-focus]').forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (!r.height) return;
      /* bez przesunięcia wjazdu (translate z [data-vip-rv]) — liczy się miejsce po wjeździe */
      var tr = (getComputedStyle(f).translate || '').split(' ');
      var dy = parseFloat(tr[1]) || 0;
      top = Math.min(top, r.top - dy);
      bottom = Math.max(bottom, r.bottom - dy);
    });
    if (bottom > top) {
      var fy = top + sy - off;
      var vis = window.innerHeight - off;
      y = Math.max(y, Math.min(fy + (bottom - top) / 2 - vis / 2, fy - 16));
    }
    return Math.max(0, y);
  }

  /* Przewijanie w zadanym czasie (easeInOutCubic); cel liczony co klatkę, bo nagłówek i treść
     nad sekcją mogą się zmienić w trakcie. Ruch użytkowniczki przerywa animację. */
  var scrollRun = 0;
  function animateScroll(el, ms) {
    var run = ++scrollRun;
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    var y0 = window.scrollY || window.pageYOffset || 0;
    var t0 = null;
    var stop = function () { if (run === scrollRun) scrollRun++; };
    var evs = ['wheel', 'touchstart', 'keydown'];
    var done = function () {
      html.style.scrollBehavior = prev;
      evs.forEach(function (n) { window.removeEventListener(n, stop); });
    };
    evs.forEach(function (n) { window.addEventListener(n, stop, { passive: true }); });
    html.style.scrollBehavior = 'auto';
    requestAnimationFrame(function frame(now) {
      if (run !== scrollRun) { done(); return; }
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / ms);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, y0 + (targetY(el) - y0) * e);
      if (p < 1) requestAnimationFrame(frame);
      else done();
    });
  }

  function scrollToEl(el, smooth, ms) {
    var y = targetY(el);
    if (smooth && !reduceMotion()) {
      if (ms > 0) animateScroll(el, ms);
      else window.scrollTo({ top: y, behavior: 'smooth' });
      return;
    }
    /* Skok bez animacji: base.css daje html scroll-behavior: smooth, więc „auto” też animowało
       (~1 s), a w karcie w tle animacja staje i strona zostawała na górze. */
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = prev;
  }

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------------- Hero: film ---------------- */
  function initHero(root) {
    if (!once(root, 'vipHero')) return;
    var v = root.querySelector('video[data-vip-video]');
    if (!v) return;
    var conn = navigator.connection;
    if (reduceMotion() || (conn && conn.saveData)) return;

    var mq = window.matchMedia(v.dataset.desk || '(min-width: 761px)');
    var visible = true;
    v.muted = true;
    v.defaultMuted = true;

    function pick(d, m) { return mq.matches ? (d || m) : (m || d); }
    function want() { return pick(v.dataset.srcD, v.dataset.srcM); }
    function fallback() { return pick(v.dataset.fbD, v.dataset.fbM); }
    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {}); /* np. iOS w trybie oszczędzania energii: zostaje plakat */
    }
    function load(src) {
      if (!src || v.getAttribute('src') === src) return;
      root.classList.remove('is-playing');
      v.src = src;
      if (visible) play();
    }

    v.addEventListener('playing', function () { root.classList.add('is-playing'); });
    v.addEventListener('error', function () {
      var fb = fallback();
      if (fb && v.getAttribute('src') !== fb) {
        v.src = fb;
        if (visible) play();
      }
    });

    load(want());
    var onChange = function () { load(want()); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (!v.getAttribute('src')) return;
        if (visible) play();
        else v.pause();
      }).observe(root);
    }
  }

  /* ---------------- Zapis ---------------- */
  function cleanName(val) {
    var n = String(val || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    if (!n) return '';
    var first = n.charAt(0);
    try { first = first.toLocaleUpperCase('pl-PL'); } catch (e) { first = first.toUpperCase(); }
    return first + n.slice(1);
  }

  function initForm(root, key) {
    var form = root.querySelector('form[data-vip-form]');
    if (!form || !once(form, 'vipForm')) return;

    var field = {};
    var err = {};
    ORDER.forEach(function (k) {
      field[k] = form.querySelector('[data-vip-field="' + k + '"]');
      err[k] = form.querySelector('[data-vip-err="' + k + '"]');
    });
    if (!field.fname || !field.email || !field.consent) return;

    function isBad(k) {
      if (k === 'fname') return field.fname.value.trim().length < 2;
      if (k === 'email') return !EMAIL_RE.test(field.email.value.trim());
      return !field.consent.checked;
    }
    function mark(k, bad) {
      field[k].setAttribute('aria-invalid', String(bad));
      var wrap = field[k].closest('[data-vip-fld]');
      if (wrap) wrap.classList.toggle('is-bad', bad);
      if (err[k]) err[k].hidden = !bad;
    }

    /* Bramka: wszystkie błędy naraz, kursor na pierwszym. true = wolno wysłać. */
    function gate() {
      var first = null;
      ORDER.forEach(function (k) {
        var bad = isBad(k);
        mark(k, bad);
        if (bad && !first) first = k;
      });
      if (first) {
        field[first].focus();
        return false;
      }
      var nm = cleanName(field.fname.value);
      field.fname.value = nm;
      try {
        sessionStorage.setItem(key + ':name', nm);
        sessionStorage.setItem(key + ':pending', '1');
      } catch (_) {}
      return true;
    }

    form.noValidate = true;
    /* Capture na document: przed captcha-bootstrapem Shopify i apkami. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!gate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    /* captcha-bootstrap po challenge'u wysyła formularz programowo (bez eventu submit). */
    var nativeSubmit = HTMLFormElement.prototype.submit.bind(form);
    form.submit = function () { if (gate()) nativeSubmit(); };

    /* Komunikat znika, gdy klientka poprawia pole. */
    ORDER.forEach(function (k) {
      field[k].addEventListener(k === 'consent' ? 'change' : 'input', function () {
        if (field[k].getAttribute('aria-invalid') === 'true') mark(k, false);
      });
    });

    /* Powrót z błędem serwera: imię wraca z sessionStorage. */
    if (root.hasAttribute('data-vip-error')) {
      try { field.fname.value = sessionStorage.getItem(key + ':name') || field.fname.value; } catch (_) {}
    }
  }

  function initZapis(root) {
    if (!once(root, 'vipZapis')) return;
    var key = root.getAttribute('data-vip-key') || 'vip';
    initForm(root, key);

    var isTyp = root.classList.contains('is-typ');
    if (isTyp || root.hasAttribute('data-vip-error')) {
      /* Cała LP zostaje — przewijamy do podziękowania / formularza od razu, zanim zniknie nakładka
         preload-screen; po load jeszcze raz (wysokość nagłówka ustala się później), chyba że
         klientka w międzyczasie sama ruszyła stronę. Bez programowego fokusu: *:focus-visible
         z base.css rysuje obrys. */
      var moved = false;
      var onMove = function () { moved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach(function (t) {
        window.addEventListener(t, onMove, { passive: true, once: true });
      });
      scrollToEl(root, false);
      var again = function () {
        if (!moved) scrollToEl(root, false);
      };
      if (document.readyState === 'complete') setTimeout(again, 0);
      else window.addEventListener('load', again);
    }

    /* Potwierdzony zapis = pierwsze wyświetlenie podziękowania po wysłaniu formularza (znacznik
       <key>:pending z gate()). Zużywamy go od razu, więc odświeżenie ani wejście z linku nie liczą się
       drugi raz. Hak GTM: data-bfv-signup (nazwa wspólna z LP BF VIP — czyta go zmienna GTM),
       bez dataLayer.push. */
    var confirmed = false;
    if (isTyp) {
      try {
        confirmed = sessionStorage.getItem(key + ':pending') === '1';
        if (confirmed) sessionStorage.removeItem(key + ':pending');
      } catch (_) {}
    }
    if (!confirmed) return;
    root.setAttribute('data-bfv-signup', '');

    /* Event Meta (nazwa z ustawień sekcji; puste = brak). */
    var ev = root.getAttribute('data-meta-event');
    if (!ev) return;
    var tries = 0;
    (function fire() {
      if (typeof window.fbq === 'function') {
        window.fbq('track', ev, { content_name: root.getAttribute('data-tag') || '' });
      } else if (tries++ < 60) {
        setTimeout(fire, 500);
      }
    })();
  }

  /* ---------------- Przełącznik (pigułki) ---------------- */
  function select(root, btn) {
    var val = btn.getAttribute('data-vip-opt');
    root.querySelectorAll('[data-vip-opt]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === btn));
    });
    root.querySelectorAll('[data-vip-item]').forEach(function (el) {
      var on = el.getAttribute('data-vip-item') === val;
      el.classList.toggle('is-active', on);
      if (el.hasAttribute('data-vip-hide')) el.hidden = !on;
      if (on && el.hasAttribute('data-vip-anim') && !reduceMotion()) {
        el.classList.remove('is-anim');
        void el.offsetWidth;
        el.classList.add('is-anim');
      }
    });
  }

  function initPick(root) {
    if (!once(root, 'vipPick')) return;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vip-opt]');
      if (!btn || !root.contains(btn) || btn.getAttribute('aria-pressed') === 'true') return;
      select(root, btn);
    });
  }

  /* ---------------- Wjazd przy przewijaniu ---------------- */
  var rvIO = null;
  function initReveal(root) {
    var els = root.querySelectorAll('[data-vip-rv]');
    if (!els.length || !once(root, 'vipRv')) return;
    if (designMode() || reduceMotion() || !('IntersectionObserver' in window)) return;
    if (!rvIO) {
      rvIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          rvIO.unobserve(en.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    root.classList.add('vip-rv-on');
    els.forEach(function (el) { rvIO.observe(el); });
  }

  /* ---------------- Kopiowanie linku ---------------- */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) {}
    ta.remove();
  }

  function onCopy(btn) {
    var url = window.location.origin + window.location.pathname;
    var done = function () {
      btn.classList.add('is-copied');
      var label = btn.querySelector('[data-vip-copy-label]');
      if (label && btn.dataset.copied) label.textContent = btn.dataset.copied;
      var sec = btn.closest('[data-vip]');
      var live = sec && sec.querySelector('[data-vip-live]');
      if (live) live.textContent = btn.dataset.live || '';
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { legacyCopy(url); done(); });
    } else {
      legacyCopy(url);
      done();
    }
  }

  /* ---------------- Delegacja kliknięć ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var copy = e.target.closest('[data-vip] [data-vip-copy]');
    if (copy) {
      onCopy(copy);
      return;
    }
    var a = e.target.closest('[data-vip] a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    scrollToEl(target, true, parseInt(a.getAttribute('data-vip-scroll-ms'), 10) || 0);
    try { history.replaceState(null, '', '#' + id); } catch (_) {}
  });

  function scrollToHash() {
    var id = window.location.hash.slice(1);
    if (!id || new URLSearchParams(window.location.search).get('typ') === '1') return;
    var t = document.getElementById(id);
    if (t && t.closest('[data-vip]')) scrollToEl(t, false);
  }
  window.addEventListener('hashchange', scrollToHash);

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('[data-vip-hero]').forEach(initHero);
    r.querySelectorAll('[data-vip-zapis]').forEach(initZapis);
    r.querySelectorAll('[data-vip-pick]').forEach(initPick);
    r.querySelectorAll('[data-vip]').forEach(initReveal);
  }

  init();
  if (document.readyState === 'complete') scrollToHash();
  else window.addEventListener('load', scrollToHash);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
